class Tabs {
  constructor(container) {
    this.container = container;
    this.tablist = container.querySelector('.js-tablist');
    this.tabs = Array.from(this.tablist.querySelectorAll('[role="tab"]'));
    this.panels = this.tabs.map(tab =>
      document.getElementById(tab.getAttribute('aria-controls'))
    );

    this.firstTab = this.tabs[0];
    this.lastTab = this.tabs[this.tabs.length - 1];

    this.init();
  }

  init() {
    this.tabs.forEach((tab, index) => {
      tab.setAttribute('tabindex', '-1');
      tab.setAttribute('aria-selected', 'false');
      this.panels[index].classList.add('is-hidden');

      tab.addEventListener('click', () => this.setSelectedTab(tab));
      tab.addEventListener('keydown', (e) => this.onKeydown(e));
    });

    this.setSelectedTab(this.firstTab, false);
  }

  setSelectedTab(tab, setFocus = true) {
    this.tabs.forEach((t, i) => {
      const panel = this.panels[i];
      const isSelected = t === tab;

      t.setAttribute('aria-selected', isSelected.toString());
      t.tabIndex = isSelected ? 0 : -1;

      if (isSelected) {
        panel.classList.remove('is-hidden');
        if (setFocus) t.focus();
      } else {
        panel.classList.add('is-hidden');
      }
    });
  }

  onKeydown(event) {
    const currentTab = event.currentTarget;
    let newTab;

    switch (event.key) {
      case 'ArrowLeft':
        newTab = this.getPreviousTab(currentTab);
        break;
      case 'ArrowRight':
        newTab = this.getNextTab(currentTab);
        break;
      case 'Home':
        newTab = this.firstTab;
        break;
      case 'End':
        newTab = this.lastTab;
        break;
    }

    if (newTab) {
      this.setSelectedTab(newTab);
      event.preventDefault();
    }
  }

  getPreviousTab(current) {
    const index = this.tabs.indexOf(current);
    return index > 0 ? this.tabs[index - 1] : this.lastTab;
  }

  getNextTab(current) {
    const index = this.tabs.indexOf(current);
    return index < this.tabs.length - 1 ? this.tabs[index + 1] : this.firstTab;
  }
}

window.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.js-tabs').forEach(tabGroup => {
    if (tabGroup.querySelector('.js-tablist')) {
      new Tabs(tabGroup);
    }
  });
});
